@let paymentView = paymentView$ | async;
@let channelView = channelView$ | async;
@let activeView = activeTab === "payment" ? paymentView : channelView;
@let firstColumn = activeTab === "payment" ? "FORMA PAGAMENTO" : "CANAL";

<div class="card p-4">
  <div class="sales-overview__header">
    <h2 class="sales-overview__title">Selecione a informação:</h2>
    <div class="sales-summary-tabs" role="tablist" aria-label="Resumo de vendas">
      <button
        type="button"
        class="sales-summary-tabs__button"
        [class.sales-summary-tabs__button--active]="activeTab === 'payment'"
        (click)="setActiveTab('payment')">
        Vendas por meio de pagamento
      </button>
      <button
        type="button"
        class="sales-summary-tabs__button"
        [class.sales-summary-tabs__button--active]="activeTab === 'channel'"
        (click)="setActiveTab('channel')">
        Vendas por canal
      </button>
    </div>
  </div>

  @if (activeView) {
    <section class="sales-overview__content">
      @if (activeView.rows.length) {
        <section class="sales-overview__chart">
          <app-pie-chart canvasId="salesOverviewChart" [colors]="activeView.colors" [segments]="activeView.segments" />
        </section>
      }
      <section class="sales-overview__table">
        <p-table [value]="activeView.rows">
          <ng-template pTemplate="header">
            <tr>
              <th>{{ firstColumn }}</th>
              <th>QUANTIDADE</th>
              <th>TOTAL EM R$</th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-row>
            <tr>
              <td>{{ row.label }}</td>
              <td>{{ row.quantity }}</td>
              <td>{{ row.amount | currency: "BRL" }}</td>
            </tr>
          </ng-template>
          <ng-template pTemplate="footer">
            <tr>
              <td>Total:</td>
              <td>
                <b>{{ activeView.totalQuantity }}</b>
              </td>
              <td>
                <b>{{ activeView.totalValue | currency: "BRL" }}</b>
              </td>
            </tr>
          </ng-template>
        </p-table>
      </section>
    </section>
  } @else {
    <p-skeleton height="18rem" />
  }
</div>
